/* <sst-collection>: filter/sort changes re-render the section in place (Section Rendering API)
   and keep the open dropdown open so shoppers can tick several values. */
if (!customElements.get('sst-collection')) {
  customElements.define(
    'sst-collection',
    class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('change', (e) => {
          if (e.target.form) this.update(e.target);
        });
        this.addEventListener('submit', (e) => e.preventDefault());
      }

      async update(input) {
        const params = new URLSearchParams(new FormData(input.form)).toString();
        const openDd = this.querySelector('.sst-dd[open]')?.dataset.dd;

        this.controller?.abort();
        this.controller = new AbortController();
        let html;
        try {
          html = await fetch(`${location.pathname}?${params}&section_id=${this.dataset.sectionId}`, {
            signal: this.controller.signal,
          }).then((r) => r.text());
        } catch (e) {
          return; /* superseded by a newer change */
        }

        const next = new DOMParser().parseFromString(html, 'text/html').querySelector('sst-collection');
        if (!next) return;
        this.innerHTML = next.innerHTML;
        history.replaceState(null, '', `${location.pathname}?${params}`);

        if (openDd) this.querySelector(`.sst-dd[data-dd="${CSS.escape(openDd)}"]`)?.setAttribute('open', '');
        this.querySelector(`[name="${CSS.escape(input.name)}"][value="${CSS.escape(input.value)}"], select[name="${CSS.escape(input.name)}"]`)?.focus();
      }
    }
  );

  /* Close filter dropdowns on outside click or Escape. */
  document.addEventListener('click', (e) => {
    document.querySelectorAll('.sst-dd[open]').forEach((dd) => dd.contains(e.target) || dd.removeAttribute('open'));
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const dd = document.querySelector('.sst-dd[open]');
    if (!dd) return;
    dd.removeAttribute('open');
    dd.querySelector('summary').focus();
  });
}
